import React from 'react';
import { NavLink } from 'react-router-dom';

const MyAccountSideBar = ({ active, sidebarController }) => {
  return (
    <aside className={`my-account-sidebar bg-white p-3 ${active ? "d-block" : "d-none d-lg-block"}`}>
      {/* Mobile header with close button */}
      <div className="d-flex justify-content-between align-items-center mb-3 d-lg-none">
        <h5 className="mb-0">Menu</h5>
        <button onClick={sidebarController} className="btn btn-link text-decoration-none">
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <nav className="nav flex-column">
        <NavLink
          to="/account"
          className={({ isActive }) =>
            `nav-link text-sm ${isActive ? "bg-main-600 text-white rounded" : "text-gray-600"}`
          }
        >
          My Account
        </NavLink>
        <NavLink
          to="/address-book"
          className={({ isActive }) =>
            `nav-link text-sm ${isActive ? "bg-main-600 text-white rounded" : "text-gray-600"}`
          }
        >
          My Address Book
        </NavLink>
      </nav>
      <nav className="nav flex-column">
        <NavLink
          to="/my-orders"
          className={({ isActive }) =>
            `nav-link text-sm ${isActive ? "bg-main-600 text-white rounded" : "text-gray-600"}`
          }
        >
          My Orders
        </NavLink>
      </nav>
    </aside>
  );
};

export default MyAccountSideBar;
